var thumbnailProgressBar = function ($carousell, $progressBar, options) {
  var progressTicker = null,
    progressClass = 'show-progress';

  if ($progressBar.length) {
    //Progressbar
    $carousell.ev.on('rsAutoPlay:play', function (event) {
      var currentIndex = $carousell.currSlideId,
        $currentProgressBar = $progressBar.eq(currentIndex),
        currentTicker = 0,
        percentage = 0;

      $currentProgressBar.addClass(progressClass);

      if (progressTicker) {
        clearInterval(progressTicker);
      }
      progressTicker = setInterval(function () {
        currentTicker++;

        percentage = 100 / (options.autoPlay.delay / (currentTicker * 10));

        $currentProgressBar.css({ 'width': percentage + '%' });

      }, 10);
    });

    $carousell.ev.on('rsAutoPlay:pause', function (event) {
      var currentIndex = $carousell.currSlideId,
        $currentProgressBar = $progressBar.eq(currentIndex);

      $currentProgressBar.removeClass(progressClass);
      if (progressTicker) {
        clearInterval(progressTicker);
        progressTicker = null;
        $currentProgressBar.css({ 'width': '100%' });
      }
    });
  }
};

var thumbnailCarousell = function () {

  var selector = '.thumbnail-carousell',
    $element = $(selector);

  if ($element.length) {
    var $slides = $element.find(selector + '__slides'),
      $thumbnails = $('.thumbnail-carousell__thumbs__item'),
      options = {
        imageScaleMode: 'fill',
        imageScalePadding: 0,
        controlNavigation: 'bullets',
        arrowsNav: false,
        slidesSpacing: 0,
        loop: true,
        navigateByClick: false,
        keyboardNavEnabled: true,
        addActiveClass: true,
        fadeinLoadedSlide: true,
        block: {
          fadeEffect: true,
          moveEffect: 'none',
          moveOffset: 20,
          speed: 400,
          easing: 'easeOutSine',
          delay: 200
        },
        autoPlay: {
          enabled: true,
          pauseOnHover: true,
          stopAtAction: true,
          delay: 4500
        },
        video: {
          autoHideArrows: true,
          autoHideControlNav: true,
          autoHideBlocks: true,
          youTubeCode: '<iframe loading="lazy" src="//www.youtube.com/embed/%id%?rel=1&autoplay=1&showinfo=0" frameborder="no"></iframe>',
          vimeoCode: '<iframe loading="lazy" src="//player.vimeo.com/video/%id%?byline=0&amp;portrait=0&amp;autoplay=1" frameborder="no" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>'
        },
      },
      $carousell = $slides.royalSlider(options).data('royalSlider');

    //Go to correct slide
    $thumbnails.on('click', function (e) {
      e.preventDefault();
      var $this = $(this),
        goToID = $this.index();

      $carousell.goTo(goToID);
      return false;
    });

    $(document).on('click', selector + '__slides__item__play', function (e) {
      e.preventDefault();

      $carousell.playVideo();

      return false;
    });

    $thumbnails.eq(0).addClass('is-active');

    $carousell.ev.on('rsAfterSlideChange', function (event) {
      var currentIndex = $carousell.currSlideId,
        $currentThumbnail = $thumbnails.eq(currentIndex);


      $thumbnails.removeClass('is-active');
      $currentThumbnail.addClass('is-active');
    });

    //thumbnailProgressBar($carousell, $('[data-rsProgress]'), options);

    $carousell.updateSliderSize(true);

    $(document).on('resized', function () {
      $carousell.updateSliderSize(true);
      setTimeout(function () {
        $carousell.updateSliderSize(true);
      }, 500);
    });

  }

};

$(window).on('load', function () {
  thumbnailCarousell();
});
